<template>
  <div :class="bemClass()">
    <div :class="bemClass('trigger')">
      <slot></slot>
    </div>
    <div :class="bemClass('content')">
      <span :class="bemClass('text')">
        <slot name="tooltip"></slot>
      </span>
    </div>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import useBem from '../../compositions/bem'

export default {
  name: 'SelTooltip',
  props: {
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-tooltip', modifier)

    return {
      bemClass
    }
  }
}
</script>

<style scoped>
  .sel-tooltip {
    position: relative;
    display: inline-block;
  }

  .sel-tooltip-trigger {
    cursor: pointer;
  }

  .sel-tooltip-content {
    position: absolute;
    left: 50%;
    bottom: 100%;
    width: 120px;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s;
    transform: translate3d(-50%, 0, 0);
    padding: 5px;
    border-radius: 2px;
    text-align: center;
    background: #fff;
    border: 1px solid #000;

    .sel-tooltip:hover & {
      opacity: 1;
      visibility: visible;
    }
  }

  .sel-tooltip-text::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #000 transparent transparent transparent;
  }
</style>
